import { render, staticRenderFns } from "./SubjectIndexView.vue?vue&type=template&id=6a861c58&scoped=true"
import script from "./SubjectIndexView.vue?vue&type=script&lang=js"
export * from "./SubjectIndexView.vue?vue&type=script&lang=js"
import style0 from "./SubjectIndexView.vue?vue&type=style&index=0&id=6a861c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a861c58",
  null
  
)

export default component.exports